import { Input, SelectInput } from 'components/__new/common/form';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import { ReactComponent as IconAdd } from 'assets/images/icons/icon-add.svg'
import { ReactComponent as IconMenu } from 'assets/images/icons/menu.svg'
import { ReactComponent as IconChevroletDown } from 'assets/images/icons/chevrolet-down.svg'
import Maybe from 'components/__new/common/Maybe';

const EditWorkflowStage = ({
    form,
    setForm,
    workflow,
}) => {
    const { roles, rolesLoading } = useSelector(s => s.entities.approvals);
    const [isCollapsed, setIsCollapsed] = useState(form?.stages?.map(() => true));

    const addNewStage = () => {
        setForm({
            ...form,
            stages: [...form?.stages, { name: "", approverRoleId: "" }]
        });
        setIsCollapsed([...isCollapsed, true]);
    };
    
    const handleStageChange = (index, key, value) => {
        const newStages = [...form?.stages];
        newStages[index][key] = value;
        setForm({ ...form, stages: newStages });
    };
    
    const toggleCollapse = (index) => {
        const newIsCollapsed = [...isCollapsed];
        newIsCollapsed[index] = !newIsCollapsed[index];
        setIsCollapsed(newIsCollapsed);
    };

    useEffect(() => {
        if (!form?.stages || form?.stages?.length === 0) {
            setForm({
                ...form,
                stages: workflow?.WorkflowStages?.map(stage => ({
                    name: stage?.name || "",
                    approverRoleId: stage?.approvalRole?.id || "",
                    id: stage?.id || ""
                })) || [{ name: "", approverRoleId: "", id: "" }]
            });
            setIsCollapsed(new Array(workflow?.WorkflowStages?.length).fill(true));
        }
        // eslint-disable-next-line
    }, [workflow]);

    return (
        <div className="w-full pt-4 text-[#121619] space-y-7">
            {form?.stages?.map((stage, index) => (
                <div key={index}>
                    <div className='bg-[#F8F8F8] flex justify-between items-center px-3 py-4 rounded-lg border mt-3 border-[#E9E9E9]'>
                        <div className='flex items-center font-bold uppercase'>
                            <IconMenu className='mr-2'/> Stage {index + 1}
                        </div>
                        <div
                            onClick={() => toggleCollapse(index)}
                            className={`cursor-pointer transform transition-transform duration-300`}
                        >
                            <IconChevroletDown  className={`${isCollapsed[index] ? 'rotate-0' : '-rotate-90'}`}/>
                        </div>
                    </div>
                    <Maybe condition={isCollapsed[index]}>
                        <div className='mt-4'>
                            <Input
                                type="text"
                                label="Stage Name"
                                value={stage?.name || ""}
                                className="form-input"
                                onChange={(e) => handleStageChange(index, 'name', e.target.value)}
                                placeholder="Enter a stage name"
                            />

                            <SelectInput
                                disabled={rolesLoading}
                                label="Assigned Approval Role"
                                value={stage?.approverRoleId || ""}
                                onChange={(e) => handleStageChange(index, 'approverRoleId', e.target.value)}
                            >
                                <option value="">Select role</option>
                                {roles?.error === false && roles?.data?.data?.map((role) => (
                                    <option key={role.id} value={role.id}>{role.name}</option>
                                ))}
                            </SelectInput>
                        </div>
                    </Maybe>
                </div>
            ))}

            <div onClick={addNewStage} className='flex items-center text-ep-primary-600 cursor-pointer font-medium'>
                <IconAdd className='mr-2'/>
                Add a New Stage
            </div>
        </div>
    )
}

export default EditWorkflowStage;